import React, { useMemo, useRef, useState } from "react";

import { Box, Button, Stack, Typography } from "@mui/material";
// import { useDocumentSectionSelect } from "store";
import { MaterialTooltip } from "components/tooltips/MaterialTooltip";
import { DocumentSection, IAiFile } from "store/types";

interface IProps {
  section: DocumentSection;
  onAskAi: () => void;
  hidden: boolean;
}

export const FilesList: React.FC<IProps> = ({ onAskAi, section, hidden }) => {
  const [seeAll, setSeeAll] = useState<boolean>(false);
  const filesListRef = useRef<HTMLDivElement>(null);

  const sectionFilesLength = useMemo(() => section?.ai_files?.length, [section?.ai_files]);

  return (
    <Stack
      sx={{
        backgroundColor: sectionFilesLength ? "#F6F8FC" : "#fff",
        padding: sectionFilesLength ? "20px" : "",
        borderRadius: "3px"
      }}
      gap="10px"
    >
      {sectionFilesLength ? (
        <Stack flexDirection="row" justifyContent="space-between">
          <Typography sx={{ fontSize: "12px", fontWeight: "500", color: "#071F35" }}>
            {`${sectionFilesLength} files selected:`}
          </Typography>

          <Stack direction="row" gap="10px">
            {!hidden && (
              <Button
                disabled={section?.ai_status === "in-progress"}
                size="sm"
                variant="outlined"
                sx={{
                  minWidth: "60px !important",
                  maxWidth: "60px !important",
                  background: "#fff",
                  whiteSpace: "nowrap"
                }}
                onClick={onAskAi}
              >
                {sectionFilesLength ? "Edit Files" : "Add Files"}
              </Button>
            )}
          </Stack>
        </Stack>
      ) : null}

      <Stack
        ref={filesListRef}
        flexDirection="row"
        gap="4px"
        sx={{ maxHeight: seeAll ? "100%" : "20px", overflow: "hidden", maxWidth: "100%", flexWrap: "wrap" }}
      >
        {section?.ai_files?.map((file: IAiFile) => (
          <MaterialTooltip isShow title={file.name} placement="top" key={file.id}>
            <Box sx={{ backgroundColor: "#DBE8F5", borderRadius: "20px", padding: "4px" }}>
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: "400",
                  color: "#071F35",
                  lineHeight: "12px",
                  padding: "0 5px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  maxWidth: "150px"
                }}
              >
                {file.name}
              </Typography>
            </Box>
          </MaterialTooltip>
        ))}
      </Stack>
      {/* if the height of the stack is greater than 20px, show the see all button  */}
      {filesListRef?.current?.scrollHeight && filesListRef?.current?.scrollHeight > 20 ? (
        <Typography
          onClick={() => setSeeAll((prev) => !prev)}
          sx={{ fontSize: "12px", fontWeight: "400", color: "#26A6AE", cursor: "pointer" }}
        >
          {seeAll ? "Hide" : "See All"}
        </Typography>
      ) : null}
    </Stack>
  );
};
